import React, { useState } from 'react';
import clsx from 'clsx';

import dots from 'assets/images/dots.png';

import { InfoButton } from 'components';
import { Grid, Box, Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    gridItem: {
        position: 'relative',
        zIndex: 1,
    },
    gridItemMobile: {
        display: 'flex',
        cursor: 'pointer',
        height: 74,
        borderRadius: 6,
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        paddingLeft: 24,
        paddingRight: 16,

        '&$selected': {
            borderColor: theme.palette.primary.main,
            background: '#FFFBF0',
        },
    },
    label: {
        fontSize: 18,
        cursor: 'pointer',
        textAlign: 'center',

        '&$selected, &:hover': {
            textDecoration: 'underline',
            color: theme.palette.primary.main,
        },

        [theme.breakpoints.down('md')]: {
            fontSize: 14,
            textAlign: 'left',
            '&$selected, &:hover': {
                textDecoration: 'none',
                color: 'inherit',
            },
        },
        '& > span': {
            display: 'block',
        },
    },
    choice: {
        cursor: 'pointer',
        position: 'relative',
        height: 293,
        borderRadius: 6,
        backgroundSize: 'cover',
        boxShadow: '0 5px 40px 20px #00000008',
        backgroundPosition: 'center',
        backgroundColor: theme.palette.grey[200],

        '&:hover::before, &$selected::before': {
            content: '""',
            position: 'absolute',
            top: -18,
            left: -18,
            width: '100%',
            height: '100%',
            borderRadius: 6,
            backgroundImage: `url(${dots})`,
            backgroundSize: 18,
            zIndex: -1,
        },
    },
    smallChoice: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: theme.palette.grey[200],
        '&$shrink': {
            backgroundSize: '100% 100%',
        },
    },
    shrink: {},
    selected: {},
}));

const backgroundStyle = backgroundImage => ({
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'white',
});

const AdditionalInfo = ({ additionalInfo }) => {
    if (additionalInfo) {
        return (
            <Box textAlign="center">
                {typeof additionalInfo === 'string' ? (
                    <Typography variant="body1" color="inherit">
                        {additionalInfo}
                    </Typography>
                ) : (
                    additionalInfo
                )}
            </Box>
        );
    }
    return null;
};

export const LargeChoice = props => {
    const {
        selected,
        handleChange,
        label,
        title,
        content,
        selectType,
        subLabel,
        backgroundImage,
        additionalInfo,
    } = props;
    const classes = useStyles();
    const [hovering, setHovering] = useState(false);

    return (
        <Grid item xs={12} sm={5} className={classes.gridItem}>
            <Box
                className={clsx({
                    [classes.choice]: true,
                    [classes.selected]: selected,
                })}
                onClick={handleChange}
                onMouseOver={() => setHovering(true)}
                onMouseOut={() => setHovering(false)}
                style={backgroundStyle(backgroundImage)}
            />
            <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={2}>
                <Typography
                    variant="body1"
                    onClick={handleChange}
                    className={clsx({
                        [classes.label]: true,
                        [classes.selected]: selected || hovering,
                    })}
                    color={selected || hovering ? 'primary' : 'inherit'}
                >
                    {label}
                    {subLabel && <span>{subLabel}</span>}
                </Typography>
                {selectType === 'role' && (
                    <InfoButton disableMarginBottom title={title} content={content} />
                )}
            </Box>
            <AdditionalInfo additionalInfo={additionalInfo} />
        </Grid>
    );
};

export const MobileChoice = props => {
    const { selected, handleChange, label, title, content, selectType, subLabel, backgroundImage } =
        props;
    const classes = useStyles();

    return (
        <Grid
            item
            xs={12}
            onClick={handleChange}
            className={clsx({
                [classes.gridItemMobile]: true,
                [classes.selected]: selected,
            })}
        >
            <Box
                flex="0 1 74px"
                className={clsx({
                    [classes.smallChoice]: true,
                    [classes.shrink]: selectType === 'fund',
                })}
                style={backgroundStyle(backgroundImage)}
            />
            <Box
                flex="1 1"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                pl={2}
            >
                <Typography
                    variant="body1"
                    color="inherit"
                    onClick={handleChange}
                    className={clsx({
                        [classes.label]: true,
                        [classes.selected]: selected,
                    })}
                >
                    {label}
                    {subLabel && <span>{subLabel}</span>}
                </Typography>
                {selectType === 'role' && (
                    <InfoButton disableMarginBottom title={title} content={content} />
                )}
            </Box>
        </Grid>
    );
};
